module.exports = __webpack_public_path__ + "img/eyedropper.cc3d479f.png";